import React from 'react';
import { Link } from 'react-router-dom';

const BusinessPage = () => (
  <div id="content">
    <div className="container-fluid bg-dark-steel-grey bottom-border-red">
      <div className="container">
        <div className="row content-block no-bottom-padding">
          <div className="col-xs-10 col-xs-push-1 col-lg-4 col-lg-push-0 md-align-center">
            <h2 className="md-remove-breaks">Let us handle <br />the parking <br />so you can <br /><strong>handle the <br />business</strong></h2>
            <p className="callout">Time searching for parking. Drive-up rates. Paper trails. Accounting hassles. Runaway expenses.</p>
            <p className="callout">Not anymore.</p>
            <p className="callout">ParkWhiz for Business provides an online system to manage your employee and visitor parking --saving your business time and money.</p>
            <p className="callout">Have questions or need help getting started? <a href="mailto:business@parkwhiz.com">Contact us</a> and one of our dedicated account representatives will be happy to help!</p>
          </div>
          <div className="col-xs-10 col-xs-push-1 col-sm-6 col-sm-push-3 col-lg-8 col-lg-push-0 text-right">
            <img src="/static/images/business/home/PW4B-Landing-Page-demo_thumb.gif" alt="Animated Demo" id="demo" />
          </div>
        </div>
      </div>
    </div>
    <div className="container-fluid bg-dark-steel-grey" id="homepage-image-block-1">
      <div className="container">
        <div className="row content-block">
          <div className="col-xs-10 col-xs-push-1 col-sm-7 col-sm-push-2 col-md-5 col-md-push-2">
            <h4 className="red capitalize"><em>Employee Parking</em></h4>
            <h3 className="blue">HASSLE-FREE PARKING WHEREVER YOUR BUSINESS TAKES YOU.</h3>
            <p>Calling on clients? We've got you covered. Just have employees use our handy app to book in advance. They'll get directions and discounted parking -- ready and waiting for their arrival. You'll get an integrated accounting system that requires no paper and tracks every parking expense in real time. Win, win.</p>
          </div>
        </div>
      </div>
    </div>
    <div className="container-fluid background-off-white" id="homepage-image-block-2">
      <div className="container">
        <div className="row content-block">
          <div className="col-xs-10 col-xs-push-1 col-sm-7 col-sm-push-0">
            <div id="floating-circle">
              <img src="/static/images/business/home/background-home-2@2x.jpg" alt="" />
            </div>
          </div>
          <div className="col-xs-10 col-xs-push-1 col-sm-5 col-sm-push-0">
            <h4 className="red capitalize"><em>Visitor Parking</em></h4>
            <h3 className="blue">HELP YOUR CLIENTS VISIT YOUR BUSINESS.</h3>
            <p>Your visitors never had it so good. With ParkWhiz for Business, you can book them parking in advance--and pay for a free or discounted pass. It's simple on your online dashboard. They'll get a virtual pass with full directions and instructions. You'll get clients who feel appreciated and relaxed.</p>
          </div>
        </div>
      </div>
    </div>
    <div className="container-fluid bg-dark-steel-grey" id="homepage-image-block-3">
      <div className="container">
        <div className="row content-block">
          <div className="col-xs-10 col-xs-push-1 col-sm-7 col-sm-push-2 col-md-5 col-md-push-2">
            <h4 className="red capitalize"><em>Track and Manage</em></h4>
            <h3 className="blue">SIMPLE PARKING, EASY SAVINGS.</h3>
            <p>Time and money saved--that's the benefit of ParkWhiz.  With our no-cost business program, we’ve found the spots and done the negotiating for you.  At more than 5,000 locations and 800,000 spaces, nationwide, you'll get parking at up to 50% off drive-up rates.  Simply sign up to save. That's right--savings without the expense.</p>
          </div>
        </div>
      </div>
    </div>
    <div className="container-fluid bg-blue equalizer-watch">
      <div className="container">
        <div className="row content-block no-bottom-padding">
          <div className="col-xs-12 col-sm-7 col-sm-pull-1 col-md-6 col-md-pull-0 text-left hidden-xs equalizer">
            <img src="/static/images/business/home/graphic-app@2x.png" alt="Application Screenshots" className="application-screenshots" />
          </div>
          <div className="col-xs-10 col-xs-push-1 col-sm-5 col-sm-push-0 col-md-6 equalizer">
            <div>
              <h2>HOW THE MAGIC HAPPENS.</h2>
              <div className="col-xs-12 col-sm-10">
                <p><strong>For employees</strong> on your business account, our app guides them to the perfect space. They have only to search, book at a discount, park and relax. All the directions, instructions and expenses are taken care of.</p>
                <p><strong>For your clients</strong>, you book for them from the comfort of your office. They receive the pass in advance--on their phones or online--and come visit.</p>
                <div className="btn-toolbar">
                  <div className="btn-group">
                    <a href="https://app.appsflyer.com/id595743376?pid=ParkWhiz.com&c=PW4B" target="_blank">
                      <img src="/static/images/business/buttons/button-apple-app-store@2x.png" className="button-apple-app-store" alt="Apple Store" />
                    </a>
                  </div>
                  <div className="btn-group">
                    <a href="https://app.appsflyer.com/com.parkwhiz.driverApp?pid=ParkWhiz.com&c=PW4B" target="_blank">
                      <img src="/static/images/business/buttons/button-google-play@2x.png" className="button-google-play" alt="Google Play" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xs-12 text-left hidden-sm hidden-md hidden-lg">
            <img src="/static/images/business/home/graphic-app@2x.png" alt="Application Screenshots" className="application-screenshots" />
          </div>
        </div>
      </div>
    </div>
    <div className="container-fluid bg-dark-steel-grey">
      <div className="container">
        <div className="row content-block">
          <div className="col-xs-10 col-xs-push-1 cols-sm-10 col-sm-push-1 col-md-8 col-md-push-2 col-lg-6 col-lg-push-3 text-center">
            <div id="numbers" className="row">
              <div className="col-xs-10 col-xs-push-1 col-sm-12 col-sm-push-0">
                <p className="callout">Parking where you need it, when you want it, at a discount -- for employees <em>and</em> for clients.</p>
              </div>
              <div className="col-xs-12 col-sm-2">
                <h2>150+</h2>
                <h6>Cities</h6>
              </div>
              <div className="col-xs-12 col-sm-1">
                <hr />
              </div>
              <div className="col-xs-12 col-sm-3">
                <h2>5,000+</h2>
                <h6>Garages</h6>
              </div>
              <div className="col-xs-12 col-sm-1">
                <hr />
              </div>
              <div className="col-xs-12 col-sm-5">
                <h2>2,000,000+</h2>
                <h6>Customers</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="container-fluid bg-off-white equalizer-watch">
      <div className="container">
        <div className="row content-block">
          <div className="col-xs-10 col-xs-push-1 text-center">
            <div className="row">
              <div className="col-xs-10 col-xs-push-1 col-sm-12 col-sm-push-0">
                <h3 className="capitalize dark">Take a look at how our solutions easily fit your business needs</h3>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-6">
                <div className="rounded bg-white">
                  <div className="equalizer">
                    <img src="/static/images/business/icons-cta/cta-visit-your-clients@2x.png" id="icon-cta-visit-your-clients" alt="" />
                    <h3 className="blue">Go Visit Your Clients</h3>
                    <p>Save now on employee parking and keep expenses in check.</p>
                  </div>
                  <Link to={{ pathname: '/business/visit-your-clients' }} className="button fixed">I'm In</Link>
                </div>
              </div>
              <div className="col-xs-12 col-sm-6">
                <div className="rounded bg-white">
                  <div className="equalizer">
                    <img src="/static/images/business/icons-cta/cta-clients-visit-you@2x.png" id="icon-cta-clients-visit-you" alt="" />
                    <h3 className="blue">Have Clients Visit You</h3>
                    <p>Save your visitors a space and send them a pass in advance.</p>
                  </div>
                  <Link to={{ pathname: '/business/clients-visit-you' }} className="button fixed">Sounds Great</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default BusinessPage;
